// import { instanceOf } from "prop-types";

const unhandled = [];

function parseSchema(xml) {
  const start = xml.querySelector('start');
  const structure = {
    tag: 'start',
    children: getChildren(start, xml, {})
  };

  return structure;
}

function getPathChain(path) {
  return path.replace(/></g, '-').replace(/>/g, '').replace(/</g, '').split('-');
}

function generateXml(schema, values, defaults) {
  const parser = new DOMParser();
  const base = `<?xml version="1.0" encoding="UTF-8"?>
  <gavedoc version="1.0">
  </gavedoc>`;
  const doc = parser.parseFromString(base, "application/xml");

  const gavedoc = doc.querySelector('gavedoc');
  Object.keys(defaults).forEach(k => {
    defaults[k] = [defaults[k]];
  });
  values = Object.assign({}, defaults, values);
  gavedoc.appendChild(getXmlNode(schema.children[0].children[1], values, doc, '<gavedoc>'));
  const serializer = new XMLSerializer();

  return serializer.serializeToString(doc);
}

function generateXmlForGA(schema, values, defaults) {
  const parser = new DOMParser();
  const base = `<?xml version="1.0" encoding="UTF-8"?>
  <gavedoc version="1.0">
  </gavedoc>`;
  const doc = parser.parseFromString(base, "application/xml");

  const gavedoc = doc.querySelector('gavedoc');
  Object.keys(defaults).forEach(k => {
    defaults[k] = [defaults[k]];
  });
  values = Object.assign({}, defaults, values);
  gavedoc.appendChild(getXmlNode(schema.children[0].children[1], values, doc, '<gavedoc>'));

  var tag = doc.querySelectorAll("other, height_predictions, blood_pressure_diast, blood_pressure_syst, heartrate, height_sds, months_sds, twrus_sd, twrus_percentile, target_gp_sd, target_bxp_sd, bxp_cm");
  var f=Array.from(tag);
  f.forEach(x=>x.remove());
    
  const serializer = new XMLSerializer();
  return serializer.serializeToString(doc);
}


function checkValidity(schema, values) {
  return checkNodeValidity(schema.children[0].children[1], values, '<gavedoc>');
}

function checkNodeValidity(node, values, path) {
  const nodePath = `${path}<${node.name}>`;
  let valid = true;
  // check children
  node.children.forEach(child => {
    if (!child.name) return;
    const childPath = `${nodePath}<${child.name}>`;
    const hasValues = Object.keys(values).some(p => p.indexOf(childPath) !== -1);

    if (!child.optional && !hasValues) {
      console.log(`Missing value for ${childPath}`);
      valid = false;
    }

    if (hasValues) {
      if (child.multiple && values[childPath] && values[childPath].length) {
        // for multiple node, check instances
        const instanceValues = values[childPath];
        instanceValues.forEach(v => {
          valid = valid && checkNodeValidity(child, v, nodePath);
        });
      }
      else {
        // otherwise just traverse
        valid = valid && checkNodeValidity(child, values, nodePath);
      }
    }
  });
  return valid;
}


function getXmlNode(node, values, doc, path) {
  const xmlNode = doc.createElement(node.name);
  const nodePath = `${path}<${node.name}>`;

  if (nodePath in values && values[nodePath].length) {
    let textValue = values[nodePath][0];

    if (textValue instanceof Date) {
      textValue = textValue.toISOString();
    }

    if (textValue == "NaN") {
      textValue = null;
    }

    if (textValue !== null && textValue !== '') {
      xmlNode.appendChild(doc.createTextNode(textValue));
      return xmlNode;
    }
  }
  
  node.children.forEach(child => {
    const childPath = `${nodePath}<${child.name}>`;
    const hasValues = Object.keys(values).some(p => p.indexOf(childPath) !== -1);

    // check if node has value
    if (hasValues) {
      if (child.multiple) {
        // for multiple node, create a a node per instance and traverse subtrees
        const instanceValues = values[childPath];

        const childrenXmlNodes = [];

        instanceValues.forEach(v => {
          const instanceNode = getXmlNode(child, v, doc, nodePath);

          if (instanceNode.childNodes.length) {
            childrenXmlNodes.push(instanceNode);
          }
        });

        // SORT BY DATE IF CHILD (semantic requirement of schema)
        // - HAS CHILDREN[0] OF NAME "date"
        // -> access <date>-node of xml node
        // -> sort by this <date>-node (is ISOString)
        // -> only then add to parent

        if (child.children.length && child.children[0].name === "date") {
          childrenXmlNodes.sort((a, b) => {
            try {
              const dateA = a.getElementsByTagName("date")[0].childNodes[0].nodeValue;
              const dateB = b.getElementsByTagName("date")[0].childNodes[0].nodeValue;

              if (dateB < dateA) return 1;
              if (dateA < dateB) return -1;
              return 0;  
            }
            catch(e) {
              //console.error(e, childrenXmlNodes);
            }
            
          });
        }

        childrenXmlNodes.forEach(n => xmlNode.appendChild(n));
      }
      else {
        // otherwise just traverse
        const instanceNode = getXmlNode(child, values, doc, nodePath);

        if (instanceNode.childNodes.length) {
          xmlNode.appendChild(instanceNode);
        }
      }
    }
  });

  return xmlNode;
}

function getChildren(root, doc, payload) {
  let children = [];

  Array.from(root.children).forEach((element, ix) => {
    getElement(element, ix, payload);
  });

  function getElement(element, order, payload) {
    let elementData = Object.assign({}, payload, {
      tag: element.tagName,
      order: order
    });

    Array.from(element.attributes).forEach(a => {
      elementData[a.name] = a.value;
    });

    switch (element.tagName) {
      case 'ref':
        let refChildren = getChildren(doc.querySelector(`define[name="${element.getAttribute('name')}"]`), doc, payload);

        if (refChildren.length === 1 && refChildren[0].tag === 'choice') {
          refChildren[0].choiceType = element.getAttribute('name');
        }

        children = children.concat(refChildren);
        return;

      case 'interleave':
        Array.from(element.children).forEach((element, _order) => {
          getElement(element, order + _order, payload);
        });
        return;

      case 'attribute':
        return;

      case 'optional':
        Array.from(element.children).forEach((element, _order) => {
          getElement(element, order + _order, {optional: true});
        });
        return;
      
      case 'oneOrMore':
        Array.from(element.children).forEach((element, _order) => {
          getElement(element, order + _order, {multiple: true});
        });
        return;

      case 'zeroOrMore':
        Array.from(element.children).forEach((element, _order) => {
          getElement(element, order + _order, {optional: true, multiple: true});
        });
        return;

      case 'value':
        elementData.value = element.textContent;
        break;
      
      case 'data':
        elementData.type = element.getAttribute('type');
        break;

      case 'element':
        break;

      default:
        unhandled[element.tagName] = true;
    }

    elementData.children = getChildren(element, doc, {});
    
    children.push(elementData);
  }

  return children;
}

export {parseSchema, generateXml, generateXmlForGA, checkValidity, getPathChain};

var values = {
  '<gavedoc><patient><id>': ['testid123'],
  '<gavedoc><patient><firstname>': ['Dominique'],
  '<gavedoc><patient><lastname>': ['Sandoz'],
  '<gavedoc><patient><birthdate>': [new Date()],
  '<gavedoc><patient><gender>': ['male']
};


// WEBPACK FOOTER //
// ./src/parseSchema.js